module.exports = __webpack_public_path__ + "throne.png?68cd466dc7e945fed4ed3cc374c22bd2";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/throne.png
// module id = 143
// module chunks = 0